export const JSM_PRODUCT_KEY = 'jira-servicedesk.ondemand';
export const CCP_PREMIUM_OFFERING_NAME = 'Premium';
